import { render, staticRenderFns } from "./ProjectProperties.vue?vue&type=template&id=39eb34a7"
import script from "./ProjectProperties.vue?vue&type=script&lang=js"
export * from "./ProjectProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports